import { render, staticRenderFns } from "./OrderServiceList.vue?vue&type=template&id=763e9db6&scoped=true&"
import script from "./OrderServiceList.vue?vue&type=script&lang=js&"
export * from "./OrderServiceList.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceList.vue?vue&type=style&index=0&id=763e9db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e9db6",
  null
  
)

export default component.exports